import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
import { WippenSupportSpringsDesignMode, type WippenSupportSpringsDesignTarget } from '@/lib/piano/touch-design/design/wippen-support-springs-design';
import { useDesignActions, useWippenSupportSpringsDesign } from '@/hooks/store/use-design-store';
import { type KeyboardLike } from '@/lib/piano/keyboard';
const defaultSpringBalanceWeight = 9;
export const useWippenSupportSpringsTargetSelector = keyboard => {
  const $ = _c(15);
  const {
    wippenSupportSpringsDesignMode,
    wippenSupportSpringsDesignTarget,
    wippenSupportSpringsDesignLatestNumberOfSprings,
    wippenSupportSpringsDesignLatestSpringBalanceWeight,
    wippenSupportSpringsDesignLatestTensionDropIndex
  } = useWippenSupportSpringsDesign();
  const {
    updateWippenSupportSpringsDesign
  } = useDesignActions();
  let t0;
  if ($[0] !== updateWippenSupportSpringsDesign || $[1] !== wippenSupportSpringsDesignMode) {
    t0 = target => {
      updateWippenSupportSpringsDesign(wippenSupportSpringsDesignMode, target);
    };
    $[0] = updateWippenSupportSpringsDesign;
    $[1] = wippenSupportSpringsDesignMode;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const onTargetChange = t0;
  let t1;
  if ($[3] !== keyboard.size || $[4] !== updateWippenSupportSpringsDesign || $[5] !== wippenSupportSpringsDesignLatestNumberOfSprings || $[6] !== wippenSupportSpringsDesignLatestSpringBalanceWeight || $[7] !== wippenSupportSpringsDesignLatestTensionDropIndex) {
    t1 = mode => {
      if (mode === WippenSupportSpringsDesignMode.AsMeasured || mode === WippenSupportSpringsDesignMode.None) {
        updateWippenSupportSpringsDesign(mode, null);
      }
      if (mode === WippenSupportSpringsDesignMode.Constant) {
        updateWippenSupportSpringsDesign(mode, {
          numberOfSprings: wippenSupportSpringsDesignLatestNumberOfSprings ?? keyboard.size,
          springBalanceWeight: wippenSupportSpringsDesignLatestSpringBalanceWeight ?? defaultSpringBalanceWeight
        });
      }
      if (mode === WippenSupportSpringsDesignMode.SmoothTransition) {
        updateWippenSupportSpringsDesign(mode, {
          numberOfSprings: wippenSupportSpringsDesignLatestNumberOfSprings ?? keyboard.size,
          springBalanceWeight: wippenSupportSpringsDesignLatestSpringBalanceWeight ?? defaultSpringBalanceWeight,
          tensionDropIndex: wippenSupportSpringsDesignLatestTensionDropIndex ?? 1
        });
      }
    };
    $[3] = keyboard.size;
    $[4] = updateWippenSupportSpringsDesign;
    $[5] = wippenSupportSpringsDesignLatestNumberOfSprings;
    $[6] = wippenSupportSpringsDesignLatestSpringBalanceWeight;
    $[7] = wippenSupportSpringsDesignLatestTensionDropIndex;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  const onModeChange = t1;
  let t2;
  if ($[9] !== onModeChange || $[10] !== onTargetChange || $[11] !== updateWippenSupportSpringsDesign || $[12] !== wippenSupportSpringsDesignMode || $[13] !== wippenSupportSpringsDesignTarget) {
    t2 = {
      onModeChange,
      onTargetChange,
      updateWippenSupportSpringsDesign,
      wippenSupportSpringsDesignMode,
      wippenSupportSpringsDesignTarget
    };
    $[9] = onModeChange;
    $[10] = onTargetChange;
    $[11] = updateWippenSupportSpringsDesign;
    $[12] = wippenSupportSpringsDesignMode;
    $[13] = wippenSupportSpringsDesignTarget;
    $[14] = t2;
  } else {
    t2 = $[14];
  }
  return t2;
};